
/* ===== Carruseles: flechas prev/next ===== */
(function(){
  document.querySelectorAll('[data-car]').forEach(function(car){
    var track=car.querySelector('.car-track'),
        prev=car.querySelector('.prev'), next=car.querySelector('.next');
    function step(){ var f=track.firstElementChild; if(!f) return 320;
      var g=parseFloat(getComputedStyle(track).gap)||22; return f.getBoundingClientRect().width+g; }
    function sync(){ var max=track.scrollWidth-track.clientWidth-2;
      prev.disabled=track.scrollLeft<=2; next.disabled=track.scrollLeft>=max; }
    prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
    next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
    track.addEventListener('scroll',sync); window.addEventListener('resize',sync); sync();
  });
})();
